import {RegData} from "@/models/auth";
import {apiConfig} from "@/store";

export const postRegData = (data: RegData) => apiConfig.request({
    endpoint: apiConfig.endpoints?.postRegData,
    data: data});
